<template>
  <popup-special
    v-model="popStatus"
    title="优惠"
    @closed="handleClosed"
    :lazyRender="false"
  >
    <p class="pp-tip pf-medium mb48" v-if="tipText.length > 0" v-html="tipText">
      <!-- 参加<span>秒杀活动</span>和<span>平台优惠券</span>叠加，预估到手价为<span
        >&yen;2980.00</span
      > -->
    </p>
    <section class="pp-section pr8 mb60" v-if="promList.length > 0">
      <div class="pp-s-label">促销优惠</div>
      <ul class="pp-s-list">
        <li v-for="(pInfo, i) in promListWithoutRewardGift" :key="'a' + i">
          <div class="pp-name">{{ getTitle(pInfo) }}</div>
          <template v-if="pInfo.type === 999">
            <div>
              <div class="pp-desc ellicpsis">
                {{ getStatus(pInfo.orderState) }}{{ pInfo.promotionName }}
                <!-- <span class="pf-medium">&yen;199</span><span>骨盆恢复单次</span> -->
              </div>
              <div class="pp-time">
                活动时间：{{ pInfo.starttime }}至{{ pInfo.endtime }}
              </div>
            </div>
          </template>
          <template v-else-if="pInfo.type === 998">
            <div>
              <div class="pp-desc ellicpsis">
                {{ getReturnServiceCouponsPrefix(pInfo.minPayPrice)
                }}{{ getStatus(pInfo.orderState)
                }}{{ pInfo.couponList.map(item => item.couponName).join('、') }}
                <!-- <span class="pf-medium">&yen;199</span><span>骨盆恢复单次</span> -->
              </div>

              <SmallCouponList
                style="margin-top: 5px"
                v-if="pInfo.couponList && pInfo.couponList.length > 0"
                :list="pInfo.couponList"
              ></SmallCouponList>
              <div class="pp-time">
                活动时间：{{ pInfo.starttime }}至{{ pInfo.endtime }}
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="pp-desc ui-nowrap"
              v-html="getPromotionName(pInfo)"
              @click="go2Detail(pInfo)"
            >
              <!-- <span class="pf-medium">&yen;199</span><span>骨盆恢复单次</span> -->
            </div>
            <i
              class="icon-arrow-right"
              v-if="isGroupBuy(pInfo.type) || isXBuyEvent(pInfo.type)"
            ></i>
          </template>
        </li>
        <!-- <li>
          <div class="pp-name">立减</div>
          <div class="pp-desc">
            <span>新客减</span><span class="pf-medium">¥100</span
            ><span>，适用“到店催乳单次”</span>
          </div>
        </li> -->
        <li class="gift-w" v-for="(rgInfo, i) in rewardGiftList" :key="'b' + i">
          <div class="pp-name">赠品</div>
          <a class="pp-desc" @click="go2RewardDetail(rgInfo)">
            <div class="pf-medium">{{ rgInfo.promotionName }}</div>
            <div class="mt20">
              <p>参与条件：{{ getRewardCondition(rgInfo) }}</p>
              <p>
                活动时间：{{
                  rgInfo.startTime.substr(0, rgInfo.startTime.length - 3)
                }}至{{ rgInfo.endTime.substr(0, rgInfo.endTime.length - 3) }}
              </p>
              <p class="mb0">适用规格：{{ getRewardSpecifications(rgInfo) }}</p>
            </div>
            <i class="icon-arrow-right"></i>
          </a>
        </li>
        <li class="gift-w" v-if="rewardGiftList.length > 0">
          <div class="pp-desc">
            <p class="tip mb0">
              *活动以用户下单时间开始计算，满足条件的用户会收到短信通知，活动结束后凭短信联系育儿顾问领取活动礼品，若取消订单则视为放弃本次活动。
            </p>
          </div>
        </li>
      </ul>
    </section>
    <section class="pp-section" v-if="couponList.length > 0">
      <div class="pp-s-label">领取优惠券</div>
      <CouponList :list="couponList" v-if="showCouponList"></CouponList>
    </section>
    <div class="aflex pp-remark mt30">
      <i class="icon-tip mr10 mt2"></i>
      <p class="item">
        以上优惠仅为初步预估，不代表最终价格，实付价格以订单确认页为准哦
      </p>
    </div>
  </popup-special>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import PopupSpecial from '@/components/action-sheet/popup-special'
import CouponList from '../../../coupon/large/list'
import SmallCouponList from '../../../coupon/list'
import { PROMOTION_TYPES, E_PROMOTION_TYPE } from '@/config'
import { isNonEmptyArray, isNullOrEmpty } from '@/utils'
const { mapState } = createNamespacedHelpers('promotionInfo')

export default {
  props: {
    promList: Array,
    couponList: Array,
    mixPromList: Array,
    go2Detail: Function
  },
  data() {
    return {
      popStatus: false,
      showCouponList: false
    }
  },
  computed: {
    ...mapState(['skuList']),
    tipText() {
      // 参加<span>秒杀活动</span>和<span>平台优惠券</span>叠加，预估到手价为<span>&yen;2980.00</span>
      const className = 'theme-primary-font-color'
      let mixPromList = this.mixPromList
      if (!isNonEmptyArray(mixPromList)) return ''
      let { minPrice, sortPrice, couponDto, promList } = mixPromList[0]
      let { couponTypeStr = '', couponName = '' } = couponDto || {}
      let str = ''
      // 赠品不参与到价格计算中
      if (isNonEmptyArray(promList)) {
        promList = promList.filter(
          x => +x.type !== E_PROMOTION_TYPE.REWARD_GIFT
        )
      }
      const status0 = isNonEmptyArray(promList)
      const status1 = !isNullOrEmpty(couponTypeStr)
      // console.log(status0, status1)
      const pInfo = status0 ? promList[0] : {}
      const promotionTitle = this.getTitle(pInfo)
      if (status0 && status1) {
        str = `参加<span class="${className}">${promotionTitle}活动</span>和<span class="${className}">${couponTypeStr}</span>叠加，`
      } else if (status0) {
        str = `参加<span class="${className}">${promotionTitle}活动</span>，`
      } else if (status1) {
        str = `使用<span class="${className}">${couponTypeStr}</span>后，`
      }
      str += `预估到手价为<span class="${className}">&yen;${(
        minPrice / 100
      ).toFixed(2)}</span>`

      return str
    },
    promListWithoutRewardGift() {
      const list = this.promList
      return list.filter(x => +x.type !== E_PROMOTION_TYPE.REWARD_GIFT)
    },
    rewardGiftList() {
      const list = this.promList
      return list.filter(x => +x.type === E_PROMOTION_TYPE.REWARD_GIFT)
    }
  },
  methods: {
    getTitle(pInfo) {
      return PROMOTION_TYPES.get(+pInfo.type)
    },
    getStatus(state) {
      // 20-下单返
      // 30-核销返
      // 40-评价返
      if (state === 20) {
        return '下单返'
      } else if (state === 30) {
        return '核销返'
      } else if (state === 40) {
        return '评价返'
      }
      return '下单返'
    },
    getPromotionName(pInfo) {
      let { promotionName, type, promotionPrice } = pInfo
      promotionPrice = promotionPrice / 100
      const t = this.skuList.find(x => +x.skuId === +pInfo.skuId) || {}
      const { skuName = '' } = t
      if (+type === E_PROMOTION_TYPE.DISCOUNT)
        return `立减<span class="number500">&yen;${promotionPrice}</span>，适用“${skuName}”`
      if (+type === E_PROMOTION_TYPE.FLASH_SALE)
        return `<span class="number500">&yen;${promotionPrice}</span>&nbsp;${promotionName}`
      return promotionName.replace(
        /(¥|\&yen;)\d+/g,
        '<span class="number500">$&</span>'
      )
    },
    getRewardCondition(pInfo) {
      const { allLimitNum, promotionPrice, payPriceMaxLimit } = pInfo
      let priceText = `实付金额满${promotionPrice / 100}元`
      if (payPriceMaxLimit && payPriceMaxLimit > 0) {
        priceText = `实付金额${promotionPrice / 100}元-${
          payPriceMaxLimit / 100
        }元`
      }
      return `前${allLimitNum}名${priceText}赠送`
    },
    getReturnServiceCouponsPrefix(price) {
      const p = price ?? 0
      if (p && typeof p === 'number') {
        return `实付满${p / 100}元`
      }
      return ''
    },
    getRewardSpecifications(pInfo) {
      const t = this.skuList.find(x => +x.skuId === +pInfo.skuId)
      return t ? t.skuName : ''
    },
    handleClosed() {
      console.log('closed')
    },
    show() {
      this.popStatus = true
      this.$nextTick(() => {
        this.showCouponList = true
      })
    },
    go2RewardDetail(rewardInfo) {
      const {
        giftInfo: { spuId, skuId }
      } = rewardInfo
      location.href = `/v/product/${spuId}?skuId=${skuId}`
    },
    isXBuyEvent(type) {
      return +type === E_PROMOTION_TYPE.XBUY_EVENT
    },
    isGroupBuy(type) {
      return (
        // +type === E_PROMOTION_TYPE.FLASH_SALE ||
        +type === E_PROMOTION_TYPE.GROUP_BUY
      )
    }
  },
  components: {
    PopupSpecial,
    CouponList,
    SmallCouponList
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
